import React, { useEffect } from "react";
import { Redirect } from "react-router";
import { authenticationService } from "../services";
import { HomePath } from "./Home";

export const LogoutPath = "/logout";

function Logout() {
  useEffect(() => {
    authenticationService.logout();
  })

  return <Redirect to={HomePath}/>
}

export default Logout;